/**
 * functions
 */
import { updateLazy } from 'Functions/lazy';
import { initTippy } from 'Functions/tippy';

/**
 * common & components
 */
import 'Common/eshop';
import 'Common/window';
import 'Common/info-messages';
import 'Common/toggle-password';
import 'Common/global';

/**
 * script
 */
window.updateLazy = updateLazy();

document.addEventListener('DOMContentLoaded', () => {
    updateLazy();
    initTippy()
});